import script from "./SegmentCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentCreateForm.vue?vue&type=style&index=0&id=818b94b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-818b94b6"]])

export default __exports__